import React from 'react';
import MetricsGrid from './MetricsGrid';
import ChartSection from './ChartSection';
import RecentActivity from './RecentActivity';
import AIInsights from './AIInsights';

export default function Dashboard() {
  return (
    <div className="space-y-6">
      <MetricsGrid />
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <div className="xl:col-span-2">
          <ChartSection />
        </div>
        <div>
          <AIInsights />
        </div>
      </div>
      <RecentActivity />
    </div>
  );
}